//export const accent = '#f90000';
export const accent = '#FFF';
